import { gql } from "@apollo/client";

export const ADD_MEMBERS = gql`
  mutation addMembers($input: AddSkynetUserGroupMembersInput!) {
    rolesAndPermissions {
      addMembers(input: $input) {
        ids
        success
      }
    }
  }
`;
